<div class="content">

  @if (isCreating) {
    @if (creationPhase !== 'failed') {
      <!-- creating: progress -->
      <div class="wz-head">
        <span class="wz-eyebrow">World Creation Wizard</span>
        <h2 class="wz-title">Bringing <span class="gold">{{ mapName }}</span> online</h2>
      </div>

      <div class="rv-progress">
        <span class="rv-spinner" aria-hidden="true"></span>
        <p class="rv-stage" role="status">{{ creationStageLabel }}</p>
        @if (creationProgress > 0) {
          <div class="rv-bar" role="progressbar" [attr.aria-valuenow]="creationProgress" aria-valuemin="0" aria-valuemax="100">
            <span [style.width.%]="creationProgress"></span>
          </div>
          <p class="rv-pct">{{ creationProgress }}%</p>
        }
        <p class="rv-hint" [class.hint-visible]="hintVisible">{{ currentHintMessage }}</p>

        @if (isBackgroundTask) {
          <div class="wz-note">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M13 3 5 14h6l-1 7 8-11h-6z"/></svg>
            <p>Your world is being built in the background. You can close this window at any time.</p>
          </div>
        }
      </div>
    }

    @if (creationPhase === 'failed') {
      <!-- creating: failed -->
      <div class="wz-head">
        <span class="wz-eyebrow">World Creation Wizard</span>
        <h2 class="wz-title">Something went <span class="rv-danger">wrong</span></h2>
      </div>

      <div class="rv-failed">
        <span class="rv-failed-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>
        </span>
        <p class="rv-failed-msg">{{ creationErrorMsg || "We couldn't create your world." }}</p>
        <p class="wz-muted">Check your connection and try again. Nothing was charged if the world wasn't created.</p>
      </div>

      <div class="wz-actions">
        <button type="button" class="btn btn-theme" (click)="onRetry()">Try again</button>
      </div>
    }
  }

  @if (!isCreating) {
    <!-- ready to create -->
    <div class="wz-head">
      <span class="wz-eyebrow">World Creation Wizard</span>
      <h2 class="wz-title">Ready to create <span class="gold">{{ mapName }}</span></h2>
    </div>

    <p class="wz-lead">Everything's set. Press <strong>Create world</strong> to build your map and its wiki.</p>

    <div class="wz-choice">
      <div class="wz-choice-chips">
        @if (isManualMode) {
          <span class="wz-chip is-free">Manual · free</span>
        } @else {
          <span class="wz-chip">AI · {{ creditsRequired }} credit</span>
        }
      </div>
      <h3 class="wz-choice-name">{{ mapName }}</h3>
      @if (isManualMode) {
        <p class="wz-lead">Created without AI lore. Add lore and details yourself from the world's wiki.</p>
      } @else {
        <p class="wz-lead">AI will write the first lore for your world from your choices. <strong>{{ creditsRequired }} World Initialization Credit</strong> is used up when you create it.</p>
      }
    </div>

    @if (!isManualMode) {
      <div class="wz-stats">
        <div class="wz-stat">
          <span>Credits needed</span>
          <strong>{{ creditsRequired }}</strong>
        </div>
        <div class="wz-stat" [class.is-short]="!isLoading && creditsBalance < creditsRequired"
          [class.is-ok]="!isLoading && creditsBalance >= creditsRequired">
          <span>Your balance</span>
          @if (isLoading) {
            <i class="wz-spinner" aria-label="Loading"></i>
          } @else {
            <strong>{{ creditsBalance }}</strong>
          }
        </div>
      </div>
    }

    @if (showErrorMsg) {
      <div class="error-banner">
        <span class="error-text">{{ validationErrorText }}</span>
      </div>
    }

    <div class="wz-actions">
      <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
      <button type="button" class="btn btn-green" [disabled]="isLoading || (!isManualMode && creditsBalance < creditsRequired)" (click)="onCreate()">
        @if (isLoading) { <i class="wz-spinner rv-btn-spin" aria-hidden="true"></i> }
        Create world
      </button>
    </div>
  }
</div>
